import { MouseEvent, ReactNode, useCallback, useState } from 'react';
export const useTabs = ({
  labels,
  defaultActiveTabIndex = 0,
  onClick,
  onChange
}) => {
  const [currentActiveTabIndex, setCurrentActiveTabIndex] = useState(defaultActiveTabIndex);
  const onTabClick = useCallback(event => {
    onClick && onClick(event);
    const newActiveTabIndex = Number(event.target.dataset.index);
    newActiveTabIndex !== currentActiveTabIndex && setCurrentActiveTabIndex(newActiveTabIndex);
    onChange && onChange(labels[newActiveTabIndex]);
  }, [labels, onChange, onClick, currentActiveTabIndex]);
  return {
    currentActiveTabIndex,
    onTabClick
  };
};